import { MoreVertical } from 'lucide-react';

const departments = [
  {
    sno: 1,
    code: 'DEP-001',
    title: 'Human Resources',
    type: 'Administrative',
    headCount: 45,
    createdDate: 'Jan 10 2024',
    branch: 'Nova Tech 1',
  },
  {
    sno: 2,
    code: 'DEP-002',
    title: 'Finance & Accounting',
    type: 'Administrative',
    headCount: 38,
    createdDate: 'Jan 10 2024',
    branch: 'Nova Tech 2',
  },
  { sno: 3, code: 'DEP-003', title: 'Information Technology', type: 'Technical', headCount: 62, createdDate: 'Jan 15 2024', branch: 'BAA' },
  { sno: 4, code: 'DEP-004', title: 'Marketing', type: 'Administrative', headCount: 28, createdDate: 'Feb 01 2024', branch: 'BCCA' },
  { sno: 5, code: 'DEP-005', title: 'Operations', type: 'Operational', headCount: 54, createdDate: 'Feb 10 2024', branch: 'Nova' },
  { sno: 6, code: 'DEP-006', title: 'Sales', type: 'Administrative', headCount: 41, createdDate: 'Mar 05 2024', branch: 'Nova Tech 1' },
  {
    sno: 7,
    code: 'DEP-007',
    title: 'Legal & Compliance',
    type: 'Administrative',
    headCount: 18,
    createdDate: 'Mar 15 2024',
    branch: 'Nova Tech 2',
  },
  { sno: 8, code: 'DEP-008', title: 'Research & Development', type: 'Technical', headCount: 35, createdDate: 'Apr 01 2024', branch: 'BAA' },
  { sno: 9, code: 'DEP-009', title: 'Customer Support', type: 'Operational', headCount: 47, createdDate: 'Apr 20 2024', branch: 'BCCA' },
  {
    sno: 10,
    code: 'DEP-010',
    title: 'Procurement',
    type: 'Administrative',
    headCount: 22,
    createdDate: 'May 12 2024',
    branch: 'Nova Tech 1',
  },
  {
    sno: 11,
    code: 'DEP-011',
    title: 'Quality Assurance',
    type: 'Technical',
    headCount: 30,
    createdDate: 'Jun 08 2024',
    branch: 'Nova Tech 2',
  },
];

const DepartmentTable = () => {
  return (
    <div className="department-table-wrapper">
      <div className="overflow-x-auto">
        <table className="department-table">
          <thead className="department-table-head">
            <tr className="bg-gray-50 border-b border-gray-200 text-left">
              <th className="th-sno">SNO</th>
              <th className="th-code">Code</th>
              <th className="th-title">Title</th>
              <th className="th-type">Type</th>
              <th className="th-headcount">Head Count</th>
              <th className="th-created">Created Date</th>
              <th className="th-branch">Branch</th>
              <th className="th-action">Action</th>
            </tr>
          </thead>
          <tbody className="department-table-body">
            {departments.map((dept) => (
              <tr key={dept.sno} className="department-row">
                <td className="td-sno">{dept.sno}</td>
                <td className="td-code">{dept.code}</td>
                <td className="td-title">{dept.title}</td>
                <td className="td-type">{dept.type}</td>
                <td className="td-headcount">{dept.headCount}</td>
                <td className="td-created">{dept.createdDate}</td>
                <td className="td-branch">{dept.branch}</td>
                <td className="td-action">
                  <button className="action-btn">
                    <MoreVertical size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="department-pagination">
        <p className="department-pagination-text">Showing 1 to 11 of 24 departments</p>

        <div className="pagination-buttons">
          <button className="pagination-btn">&lt;</button>
          <button className="pagination-btn active">1</button>
          <button className="pagination-btn">2</button>
          <button className="pagination-btn">3</button>
          <button className="pagination-btn">4</button>
          <span className="pagination-dots">...</span>
          <button className="pagination-btn">8</button>
          <button className="pagination-btn">&gt;</button>
        </div>
      </div>
    </div>
  );
};

export default DepartmentTable;
